import React from 'react';
import PropTypes from 'prop-types';

import MaterialField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { Field } from 'redux-form';

const TextField = React.forwardRef(
  (
    {
      input,
      className,
      classNameInput,
      classNameRoot,
      classNameNotched,
      variant,
      type,
      startIcon,
      endIcon,
      onEndIconClick,
      readonly,
      rawInput,
      ...props
    },
    ref
  ) => {
    const onBlur = (event) => {
      input && input.onBlur && input.onBlur(event);
      props.onBlur && props.onBlur(event);
    };

    const onFocus = (event) => {
      input && input.onFocus && input.onFocus(event);
      props.onFocus && props.onFocus(event);
    };

    return rawInput ? (
      <input
        {...{ className, readOnly: readonly, ref }}
        {...props}
        {...input}
        {...{ onBlur, onFocus }}
      />
    ) : (
      <MaterialField
        {...props}
        className={className}
        InputProps={{
          classes: {
            input: classNameInput,
            focused: className,
            root: classNameRoot,
            notchedOutline: classNameNotched,
          },
          startAdornment: startIcon && (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ),

          endAdornment: endIcon && (
            <InputAdornment position="end" onClick={onEndIconClick}>
              {endIcon}
            </InputAdornment>
          ),
          readOnly: readonly,
        }}
        variant={variant || 'outlined'}
        type={type || 'text'}
        ref={ref}
        {...input}
        {...{ onBlur, onFocus }}
      />
    );
  }
);

const FormTextField = React.forwardRef(
  ({ onChange, onFormat, name, validate, ...props }, ref) =>
    name ? (
      <Field
        component={TextField}
        name={name}
        validate={validate}
        onChange={onChange}
        format={onFormat}
        props={{ ...props, ref }}
      />
    ) : (
      <TextField {...props} {...{ ref, onChange }} />
    )
);

TextField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFormat: PropTypes.func,
  type: PropTypes.string,
  name: PropTypes.string,
  validate: PropTypes.func,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  classNameInput: PropTypes.string,
  classNameRoot: PropTypes.string,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
};

export default FormTextField;
